export enum SolutionTypeEnum {
  BUSINESS_PROFILE_LOCATION = 'Business Profile Location',
  SOLUTION_PROFILE = 'Solution Profile',
}
